export const options_messageList_zeroLines = "KeuGh";
export const options_messageList_oneLine = "zjODxc";
export const options_messageList_twoLines = "oq32g";
export const options_messageList_inline = "Il8ale";
export default {options_messageList_zeroLines,options_messageList_oneLine,options_messageList_twoLines,options_messageList_inline};